module.exports = __webpack_public_path__ + "img/smile.08e753b3.svg";